import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const SET_TABLE_CLEAR_QUEUE = gql`
mutation SetTableClearQueue($domain: String!, $lanControllerId: Int!, $tableId: Int!) {
	controller {
		setTableClearQueue(domain: $domain, lanControllerId: $lanControllerId, tableId: $tableId) {
			code
			success
			message
		}
	}
}
`

export interface SetTableClearQueueResponse {
	controller: {
		setTableClearQueue: Def_MutationResponse
	}
}

export interface SetTableClearQueueArgs {
	domain: string;
	lanControllerId: number;
	tableId: number;
}

